<pwa-account-back [link]="'account'" />

@if (content) {
<h2 class="h3 m-t-10 p-t-3 center"
    *iCms="'title' of content; skipEmpty: true"></h2>
<p class="s1 m-t-6 center p-b-3"
   *iCms="'subtitle' of content"></p>


@if (!inProgressMissions.length && !completedMissions.length) {
<p class="p1 m-t-8 center"
   *iCms="'noMissionsTitle' of content"></p>
<p class="p2 m-t-3 center"
   *iCms="'noMissionsSubtitle' of content"></p>
}
}

@for (mission of inProgressMissions; track mission) {
<a [routerLink]="['/account/my-missions', mission.id]">
    <pwa-mission class="block m-t-2"
                 [mission]="mission"></pwa-mission>
</a>
}
@if(completedMissions.length) {
<p class="s1 m-t-6 center"
   *iCms="'completedMissionsTitle' of content"></p>
@for (mission of completedMissions; track mission) {
<a [routerLink]="['/account/my-missions', mission.id]">
    <pwa-mission class="block m-t-2"
                 [mission]="mission"></pwa-mission>
</a>
}
}
